document.addEventListener("DOMContentLoaded", function() {
    const elementsToObserve = ["#textOne", "#introVise", "#transformDIV"],
        observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                entry.isIntersecting && setTimeout(() => {
                    entry.target.classList.add("in-view")
                }, 500)
            })
        }, {
            threshold: .1
        });
    elementsToObserve.forEach(id => {
        const element = document.querySelector(id);
        if (element) {
            observer.observe(element);
            const rect = element.getBoundingClientRect();
            rect.top >= 0 && rect.bottom <= window.innerHeight && setTimeout(() => {
                element.classList.add("in-view")
            }, 500)
        }
    });

    function loadAndPlayVideo(videoElement) {
        const dataSrc = videoElement.getAttribute("data-src");
        videoElement.src = dataSrc, videoElement.load(), videoElement.play().catch(error => console.error("Error playing video:", error))
    }["viseVid", "logoVid"].forEach(videoID => {
        const video = document.getElementById(videoID);
        if (video) {
            video.muted = !0, video.loop = !0;
            const videoObserver = new IntersectionObserver(function(entries, observer2) {
                entries.forEach(function(entry) {
                    entry.isIntersecting && (loadAndPlayVideo(entry.target), videoObserver.unobserve(entry.target))
                })
            }, {
                threshold: .1
            });
            videoObserver.observe(video)
        }
    })
});

function makeBackgroundVideoTextClickable(url) {
    for (var allDivs = document.getElementsByTagName("div"), i = 0; i < allDivs.length; i++) {
        var div = allDivs[i];
        div.id && div.id.includes("background_video_text") && (div.style.cursor = "pointer", div.addEventListener("click", function() {
            window.location.href = url
        }))
    }
}
window.onload = function() {
    makeBackgroundVideoTextClickable("https://workiqtools.au/products/iq-vise")
};
//# sourceMappingURL=/s/files/1/0798/5836/8825/t/24/assets/amm-custom.js.map?v=1727796432